import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { IAppState } from '../state/app.state';
import { DocumentsService } from 'src/app/Services/Documents/documents.service';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import {
  DocumentsActions,
  GetAllDocuments,
  AddDocuments,
  EditDocuments,
  DownloadDocumentFile,
  DocumentsType,
  AddDocumentsType,
  DocumentsName,
  AddDocumentsName,
  GetTypeRecord,
  GetDocumentsById,
  GetDocumentCount,
  GetDocumentSearch,
  GetDocumentImport,
  RemoveDocument,
  RemoveDocumentSuccess,
  RemoveDocumentError,
  GetAllRecords,
  GetDocumentContentById,
  AcknowledgeDocument,
  UploadDocuments,
} from '../actions/documents.action';
import {
  DocumentContentDetails,
  DocumentDetails,
  GetDocumentByIdRequestPayload,
  GetDocumentContentByIdRequestPayload,
} from '../state/documents.state';
import { Record } from 'src/app/Layouts/admin-dashboard/food-safety-system/documents/document-details/models/records.model';
import { ToasterService } from 'src/app/Services/toastr/toaster.service';
import { ErrorHandlerService } from 'src/app/Services/error-handler/error-handler.service';

@Injectable()
export class DocumentsEffects {
  constructor(
    private actions$: Actions,
    private store: Store<IAppState>,
    private documentService: DocumentsService,
    private errorHandlerService: ErrorHandlerService
  ) {}

  documentsType$ = createEffect(() => this.actions$.pipe(
    ofType<DocumentsType>(DocumentsActions.DocumentsType),
    map((action) => action.payload),
    mergeMap((payload: any) =>
      this.documentService.documentsType(payload).pipe(
        map((result: any) => ({
          type: DocumentsActions.GetDocumentsTypeSuccess,
          payload: result,
        })),
        catchError((err) =>
          of({
            type: DocumentsActions.GetDocumentsTypeError,
            payload: err,
            from: 'documentsType',
          })
        )
      )
    )
  ));

  addDocumentsType$ = createEffect(() => this.actions$.pipe(
    ofType<AddDocumentsType>(DocumentsActions.AddDocumentsType),
    map((action) => action.payload),
    mergeMap((payload: any) =>
      this.documentService.addDocumentsType(payload).pipe(
        map((result: any) => ({
          type: '[Documents] Add Documents Type Success',
          payload: result,
        })),
        catchError((err) =>
          of({
            type: '[] Add Documents Type Error',
            payload: err,
            from: 'addDocumentsType',
          })
        )
      )
    )
  ));

  getTypeRecord$ = createEffect(() => this.actions$.pipe(
    ofType<GetTypeRecord>(DocumentsActions.GetTypeRecord),
    map((action) => action.payload),
    mergeMap((payload: any) =>
      this.documentService.getTypeRecord(payload).pipe(
        map((result: any) => ({
          type: '[Documents] Get Type Record Success',
          payload: result,
        })),
        catchError((err) =>
          of({
            type: '[] Get Type Record Error',
            payload: err,
            from: 'recordsType',
          })
        )
      )
    )
  ));

  getAllDocuments$ = createEffect(() => this.actions$.pipe(
    ofType<GetAllDocuments>(DocumentsActions.GetAllDocuments),
    map((action) => action.payload),
    mergeMap((payload: any) =>
      this.documentService.getAllDocuments(payload).pipe(
        map((result: any) => {
          console.log(result)
          return {
            type: '[Documents] Get All Documents Success',
            payload: result,
          };
        }),
        catchError((err) =>
          of({
            type: '[] Get All Documents Error',
            payload: err,
            from: 'getDocuments',
          })
        )
      )
    )
  ));

  addDocuments$ = createEffect(() => this.actions$.pipe(
    ofType<AddDocuments>(DocumentsActions.AddDocuments),
    map((action) => action.payload),
    mergeMap((payload: any) =>
      this.documentService.addDocuments(payload).pipe(
        map((result: any) => {
          if (result && result.success === false) {
            return {
              type: DocumentsActions.GetAddDocumentsError,
              payload: result,
              from: 'addDocuments',
            };
          }

          return {
            type: DocumentsActions.GetAddDocumentsSuccess,
            payload: result,
          };
        }
        ),
        catchError((err) => {
          return of({
            type: DocumentsActions.GetAddDocumentsError,
            payload: err,
            from: 'addDocuments',
          });
        })
      )
    )
  ));


  editDocuments$ = createEffect(() => this.actions$.pipe(
    ofType<EditDocuments>(DocumentsActions.EditDocuments),
    map((action) => action),
    mergeMap((action) =>
      this.documentService.editDocuments(action.payload, action.param).pipe(
        map((result: any) => {
          if (result && result.success === false) {
            return {
              type: DocumentsActions.GetEditDocumentsError,
              payload: result,
              from: 'editDocuments',
            };
          }

          return {
            type: DocumentsActions.GetEditDocumentsSuccess,
            payload: result,
          };
        }),
        catchError((err) =>
          of({
            type: DocumentsActions.GetEditDocumentsError,
            payload: err,
            from: 'editDocuments',
          })
        )
      )
    )
  ));


  getDocumentsById$ = createEffect(() => this.actions$.pipe(
    ofType<GetDocumentsById>(DocumentsActions.GetDocumentsById),
    map((action) => action.payload),
    mergeMap((payload: GetDocumentByIdRequestPayload) =>
      this.documentService.getDocumentsById(payload).pipe(
        map((result: DocumentDetails[]) => ({
          type: DocumentsActions.GetDocumentsByIdSuccess,
          payload: result,
        })),
        catchError((err) =>
          of({
            type: DocumentsActions.GetDocumentsByIdError,
            payload: err,
            from: 'getDocumentById',
          })
        )
      )
    )
  ));


  getDocumentContentById$ = createEffect(() => this.actions$.pipe(
    ofType<GetDocumentContentById>(DocumentsActions.GetDocumentContentById),
    map((action) => action.payload),
    mergeMap((payload: GetDocumentContentByIdRequestPayload) =>
      this.documentService.getDocumentContentById(payload).pipe(
        map((result: DocumentContentDetails[]) => ({
          type: DocumentsActions.GetDocumentContentByIdSuccess,
          payload: result,
        })),
        catchError((err) =>
          of({
            type: DocumentsActions.GetDocumentContentByIdError,
            payload: err,
            from: 'getDocumentContentById',
          })
        )
      )
    )
  ));


  getDocumentCount$ = createEffect(() => this.actions$.pipe(
    ofType<GetDocumentCount>(DocumentsActions.GetDocumentCount),
    map((action) => action.payload),
    mergeMap((payload: any) =>
      this.documentService.getDocumentCount(payload).pipe(
        map((result: any) => ({
          type: '[Documents] Get Documents Count Success',
          payload: result,
        })),
        catchError((err) =>
          of({
            type: '[] Get Document Count Error',
            payload: err,
            from: 'getDocumentCount',
          })
        )
      )
    )
  ));

  getDocumentSearch$ = createEffect(() => this.actions$.pipe(
    ofType<GetDocumentSearch>(DocumentsActions.GetDocumentSearch),
    map((action) => action),
    mergeMap((action) =>
      this.documentService.getDocumentSearch(action.payload, action.title).pipe(
        map((result: any) => ({
          type: '[Documents] Get Documents Search Success',
          payload: result,
        })),
        catchError((err) =>
          of({
            type: '[] Get Document Search Error',
            payload: err,
            from: 'getDocumentSearch',
          })
        )
      )
    )
  ));

  downloadDocumentFile$ = createEffect(() => this.actions$.pipe(
    ofType<DownloadDocumentFile>(DocumentsActions.DownloadDocumentFile),
    map((action) => action.payload),

    mergeMap((payload: any) =>
      this.documentService.downloadDocumentFile(payload).pipe(
        map((result: any) => ({
          type: '[Documents] Download Document File Success',
          payload: result,
        })),
        catchError((err) =>
          of({
            type: '[] Download Document File Error',
            payload: err,
            from: 'downloadDocumentFile',
          })
        )
      )
    )
  ));


  documentsName$ = createEffect(() => this.actions$.pipe(
    ofType<DocumentsName>(DocumentsActions.DocumentsName),
    map((action) => action.payload),
    mergeMap((payload: any) =>
      this.documentService.documentsName(payload).pipe(
        map((result: any) => ({
          type: '[Documents] Get Documents Name Success',
          payload: result,
        })),
        catchError((err) =>
          of({
            type: '[] Get Documents Name Error',
            payload: err,
            from: 'documentsName',
          })
        )
      )
    )
  ));

  addDocumentsName$ = createEffect(() => this.actions$.pipe(
    ofType<AddDocumentsName>(DocumentsActions.AddDocumentsName),
    map((action) => action.payload),
    mergeMap((payload: any) =>
      this.documentService.addDocumentsName(payload).pipe(
        map((result: any) => ({
          type: '[Documents] Add Documents Name Success',
          payload: result,
        })),
        catchError((err) =>
          of({
            type: '[] Add Documents Name Error',
            payload: err,
            from: 'addDocumentsName',
          })
        )
      )
    )
  ));

  getDocumentImport$ = createEffect(() => this.actions$.pipe(
    ofType<GetDocumentImport>(DocumentsActions.GetDocumentImport),
    map((action) => action.payload),
    mergeMap((payload: any) =>
      this.documentService.getDocumentImport(payload).pipe(
        map((result: any) => ({
          type: '[Documents] Get Document Import Success',
          payload: result,
        })),
        catchError((err) =>
          of({
            type: '[] Get Document Import Error',
            payload: err,
            from: 'getDocumentImport',
          })
        )
      )
    )
  ));

  uploadDocuments$ = createEffect(() => this.actions$.pipe(
    ofType<UploadDocuments>(DocumentsActions.UploadDocuments),
    map((action) => action.payload),
    mergeMap((payload: any) =>
      this.documentService.uploadDocuments(payload).pipe(
        map((result: any) => ({
          type: DocumentsActions.UploadDocumentsSuccess,
          payload: result,
        })),
        catchError((err) => {
          return of({
            type: DocumentsActions.UploadDocumentsError,
            payload: err,
            from: 'uploadDocuments',
          });
        })
      )
    )
  ));

  removeDocument$ = createEffect(() => this.actions$.pipe(
    ofType<GetDocumentImport>(DocumentsActions.RemoveDocument),
    map((action) => action.payload),
    mergeMap((payload: any) =>
      this.documentService.deleteDocument(payload).pipe(
        map((result: any) => ({
          type: DocumentsActions.RemoveDocumentSuccess,
          payload: result,
        })),
        catchError((err) =>
          of({
            type: DocumentsActions.RemoveDocumentError,
            payload: err,
            from: 'deleteDocument',
          })
        )
      )
    )
  ));


  getAllRecords = createEffect(() => this.actions$.pipe(
    ofType<GetAllRecords>(DocumentsActions.GetAllRecords),
    map((action) => action.payload),
    mergeMap((payload) =>
      this.documentService
        .getAllRecords({
          companyID: payload.companyId,
        })
        .pipe(
          map((result: Record[]) => ({
            type: DocumentsActions.GetAllRecordsSuccess,
            payload: result,
          })),
          catchError((err) =>
            of({
              type: DocumentsActions.GetAllRecordsError,
              payload: err,
            })
          )
        )
    )
  ));


  acknowledgeDocuments = createEffect(() => this.actions$.pipe(
    ofType<AcknowledgeDocument>(DocumentsActions.AcknowledgeDocument),
    map((action) => action.payload),
    mergeMap((payload) => this.documentService.acknowledgeDocuments({
      documentId: payload.documentId
    }).pipe(
      map(response => ({
        type: DocumentsActions.AcknowledgeDocumentSuccess
      })),
      catchError((err) =>
        of({
          type: DocumentsActions.ErrorAcknowledgeDocument,
          payload: err,
        })
      )
    ))
  ))
}
